export default "__VITE_ASSET__Dm0Df8tv__"